export default __webpack_public_path__ + "static/media/pianoIcon.2ce29b55.svg";